import { BodyM, Button, Heading3 } from '@casavo/base-ui'
import { motion } from 'framer-motion'
import useTranslation from 'next-translate/useTranslation'
import getConfig from 'next/config'

import { fadeInAnimation } from '@/components/framer-motion-variants'
import { useDevice } from '@/context/Device'
import { useModal } from '@/context/ModalContext'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { flexColumnSpaceBetween, marginBottom, paddingBottom } from '@/shared-styles/styles.css'
import { anchorSmoothScroll } from '@/utils/dom-interactions-helpers'
import { handleClick } from '@/utils/tracking/eventsHandlers'

import { ContentWrapper } from '../Common/ContentWrapper'

type Props = {
  similarPropertiesLength: number
}

export const ContentSuccess: React.FC<Props> = ({ similarPropertiesLength }) => {
  const { t } = useTranslation()
  const { closeModal } = useModal()
  const device = useDevice()

  const {
    publicRuntimeConfig: { imageBasePath },
  } = getConfig()

  return (
    <ContentWrapper className={sprinkles({ padding: 'l' })} origin="LISTING_CONTACT">
      <motion.div animate="animate" className={flexColumnSpaceBetween} initial="initial" variants={fadeInAnimation}>
        <div className={sprinkles({ marginX: { desktop: '5xl', mobile: 'm' }, marginY: 'auto' })}>
          <img
            alt=""
            className={sprinkles({ marginBottom: '2xl', marginX: 'auto' })}
            height={138}
            src={`${imageBasePath}/images/concepts/simple-small.svg`}
            width={138}
          />
          <Heading3 as="h2" className={paddingBottom['s-m']}>
            {t('save-search:SearchSearch_Modal_Success_Title')}
          </Heading3>
          <BodyM className={paddingBottom['2xl']}>{t('save-search:SearchSearch_Modal_Success_Subtitle')}</BodyM>
          <Button
            center
            className={marginBottom.l}
            label={t('save-search:SearchSearch_Modal_Success_CTA')}
            sizeVariant="big"
            styleVariant="secondary"
            onClick={() => {
              closeModal()
              handleClick('ListingDetailForm', 'ToSimilarPropertiesFromSaveSearchSuccess')
              setTimeout(() => {
                similarPropertiesLength > 0
                  ? anchorSmoothScroll('#similarProperties', device === 'mobile' ? 0 : -100)
                  : window.scrollTo({ behavior: 'smooth', top: 0 })
              }, 1000)
            }}
          />
        </div>
      </motion.div>
    </ContentWrapper>
  )
}
